"use client"

import React, { useContext } from "react"
import { useLocale, useTranslations } from "next-intl"

import { ModalContext } from "@/contexts/ModalProvider"
import { useSearchParams } from "next/navigation"

import {
  getDateWithMonthWithTime,
  isPastEvent,
  getGMT,
} from "@/utils/datehelpers.js"

import Container from "../../Container/Container"
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs"
import RegularButton from "../../RegularButton/RegularButton"
import styles from "./Intro.module.scss"
import LangSelector from "./LangSelector"

export default function Intro({ item }) {
  const { setOpenModal } = useContext(ModalContext)
  const lang = useLocale()
  const t = useTranslations()

  const searchParams = useSearchParams()
  const tm = searchParams.get("tm")

  const registerNow = () => {
    setOpenModal(true)

    if (_paq) {
      _paq.push([
        "trackEvent",
        "event",
        "click_registernow",
        "event_click_registernow",
      ])
    }
  }

  return (
    <section
      className={`${styles.intro} ${tm === "0" ? styles.intro_noheader : ""}`}
      id="intro"
    >
      <Container className={styles.intro__container}>
        <div className={styles.intro__text}>
          {tm !== "0" && (
            <Breadcrumbs
              home={t("breadcrumbs.home")}
              className={styles.intro__breadcrumbs}
              items={[
                { name: t("breadcrumbs.events"), link: "/events" },
                { name: item.title },
              ]}
            ></Breadcrumbs>
          )}

          <LangSelector
            item={item}
            className={`${styles.intro__lang} ${
              tm === "0" ? styles.intro__lang_noheader : ""
            }`}
          />

          <div className={styles.intro__content}>
            <div className={styles.intro__date}>
              {getDateWithMonthWithTime(item.date_time, lang)}{" "}
              {lang !== "pl" && <span>{getGMT(item.time_zone)}</span>}
            </div>
            <h1>{item.title}</h1>

            <p dangerouslySetInnerHTML={{ __html: item.short_description }}></p>

            <div className={styles.intro__location}>
              {item.type === "offline" ? (
                <a
                  href={item.place.google_maps_link}
                  target="_blank"
                  rel="noreferrer"
                  dangerouslySetInnerHTML={{ __html: item.place.address }}
                ></a>
              ) : (
                <span>
                  {t("events.liveStream")}
                  <br />
                  {item.place && item.place.address}
                </span>
              )}
            </div>

            {isPastEvent(item.date_time, item.time_zone) ? (
              <>
                {item.video_is_coming_soon ? (
                  <div className={styles.intro__label}>
                    {t("events.videoIsComing")}
                  </div>
                ) : item.video_is_not_expected ? (
                  <></>
                ) : (
                  <RegularButton
                    link="#about"
                    text={t("events.watchFull")}
                  ></RegularButton>
                )}
              </>
            ) : (
              <RegularButton
                className="register_now_btn"
                shine
                text={t("events.signUpButtonText")}
                onClick={registerNow}
              ></RegularButton>
            )}
          </div>
        </div>
      </Container>
      {item.image_webp ? (
        <img
          className={styles.intro__img}
          src={item.image_webp}
          alt={`${item.title} image`}
        />
      ) : (
        item.image && (
          <img
            className={styles.intro__img}
            src={item.image}
            alt={`${item.title} image`}
          />
        )
      )}
    </section>
  )
}
